const payPal = {
    state: {
        referralToken: null
    },
    getters: {
        getReferralToken(state) {
            return state.referralToken;
        }
    },
    mutations: {
        setReferralToken(state, referralToken) {
            state.referralToken = referralToken;
        }
    },
    actions: {
        setCurrentReferralToken({ commit }, referralToken) {
            commit('setReferralToken', referralToken);
        }
    }
};

export default payPal;
